import { createRouter, createWebHistory } from "vue-router";
import checkAuth from "@/middlewares/checkAuth";
import checkGuest from "@/middlewares/checkGuest";
import AppLayout from "@/layouts/AppLayout.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";

const routes = [
  {
    path: "/",
    meta: {
      layout: AppLayout,
      middleware: checkAuth,
    },
    children: [
      {
        path: "",
        name: "Dashboard",
        alias: "dashboard",
        component: () => import("@/views/DashboardView.vue"),
        meta: {
          breadCrumbs: [{ name: "Dashboard" }],
        },
      },
    ],
  },
  {
    path: "/auth",
    meta: { layout: AuthLayout, middleware: checkGuest },
    children: [
      {
        path: "setup",
        name: "Setup",
        component: () => import("@/views/SetupView.vue"),
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Not Found",
    component: () => import("@/views/NotFound.vue"),
  },
];
const router = new createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  //document.title = to.name;
  const middleware = to.meta.middleware;
  const context = { to, from, next };

  if (!middleware) {
    return next();
  }

  middleware({ ...context });
});

export default router;
